import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './screen/Home';
import FormPage from './screen/FormPage';
import Ringraziamento from './screen/Ringraziamento';


export default function Navigator() {
    return (
        <Router>
            <Routes>
                <Route path="/" Component={Home} />
                <Route path="/Candidatura" Component={FormPage} />
                <Route path="/Ringraziamento" Component={Ringraziamento} />
                <Route path="*" element={<h1>Not Found</h1>} />
            </Routes>
        </Router>
    );
}
